import {useEffect, useMemo} from 'react';
import useGetUserGamesApi from '@/Hooks/GetUserGamesApi/useGetUserGamesApi';

export interface TimeControlOption {
  control: string;
  label: string;
  bucket: 'Bullet' | 'Blitz' | 'Rapid' | 'Classical';
}

export const TIME_CONTROLS: TimeControlOption[] = [
  {control: '2+0', label: '2 + 0', bucket: 'Bullet'},
  {control: '3+2', label: '3 + 2', bucket: 'Blitz'},
  {control: '5+3', label: '5 + 3', bucket: 'Blitz'},
  {control: '10+5', label: '10 + 5', bucket: 'Rapid'},
  {control: '15+10', label: '15 + 10', bucket: 'Rapid'},
  {control: '25+10', label: '25 + 10', bucket: 'Classical'},
];

export const DEFAULT_TIME_CONTROL = '5+3';

const estimateSeconds = (baseSeconds: number, incrementSeconds: number) =>
  baseSeconds + 40 * incrementSeconds;

const OPTION_ESTIMATES = TIME_CONTROLS.map(o => {
  const [minutes, increment] = o.control.split('+').map(Number);
  return {control: o.control, estimate: estimateSeconds(minutes * 60, increment)};
});

export function snapToTimeControl(raw?: string | null): string {
  if (!raw) return DEFAULT_TIME_CONTROL;
  const [basePart, incPart] = String(raw).split('+');
  const base = Number(basePart);
  const increment = Number(incPart ?? 0);
  if (!Number.isFinite(base) || base <= 0) return DEFAULT_TIME_CONTROL;

  const target = estimateSeconds(base, Number.isFinite(increment) ? increment : 0);
  return OPTION_ESTIMATES.reduce((best, o) =>
    Math.abs(o.estimate - target) < Math.abs(best.estimate - target) ? o : best,
  ).control;
}

export function useRecommendedTimeControl(): string {
  const {mutate: fetchGames, data} = useGetUserGamesApi();

  useEffect(() => {
    fetchGames({page: 1});
  }, [fetchGames]);

  return useMemo(
    () => snapToTimeControl((data as any)?.data?.data?.[0]?.time_control),
    [data],
  );
}
